import Cropper from 'cropperjs';
import Popup from '../popup';
import NotificationManager from "../../utils/class/notifications";

function simulatePhotoUpload () {
  const article = document.querySelector('article');
  const { userId } = article.dataset;

  const setImage = (img) => {
    const src = img.getAttribute('src');

    img.removeAttribute('src');
    img.setAttribute('src', src);
  }

  const createImage = (wrapper) => {
    const el = document.createElement('img');

    el.setAttribute('src', `${window.location.origin}/wp-content/uploads/profile_picture/${userId}.png?v=${Date.now()}`);

    wrapper.innerHTML = '';
    wrapper.append(el);
  }

  [
    document.querySelector('#profile-picture'),
    document.querySelector('#header-profile-picture'),
    document.querySelector('#menu-profile-picture')
  ].forEach((wrapper) => {
    const img = wrapper.querySelector('img');

    if (img) {
      img.setAttribute('src', `${window.location.origin}/wp-content/uploads/profile_picture/${userId}.png?v=${Date.now()}`);

      setImage(img);
    } else {
      if (
        !wrapper.getAttribute('id').includes('header') &&
        !wrapper.getAttribute('id').includes('menu')
      ) {
        wrapper.classList.remove('site-dashboard--user-profile-placeholder');
        wrapper.classList.add('site-dashboard--user-profile-picture');  
      } else {
        wrapper.classList.remove('site-header--profile-placeholder');
        wrapper.classList.add('site-header--profile-picture');  
      }

      createImage(wrapper);
    }
  });
}

function simulatePhotoDeletion () {
  const article = document.querySelector('article');
  const fullname = article.dataset.userFullname;
  const firstChar = fullname.split('')[0];

  [
    document.querySelector('#profile-picture'),
    document.querySelector('#header-profile-picture'),
    document.querySelector('#menu-profile-picture')
  ].forEach((wrapper) => {
    if (
      !wrapper.getAttribute('id').includes('header') &&
      !wrapper.getAttribute('id').includes('menu')
    ) {
      wrapper.classList.remove('site-dashboard--user-profile-picture');
      wrapper.classList.add('site-dashboard--user-profile-placeholder');  
    } else {
      wrapper.classList.remove('site-header--profile-picture');
      wrapper.classList.add('site-header--profile-placeholder');  
    }

    wrapper.innerHTML = firstChar;
  });
}

export default function Photo () {
  const _NotificationManager = new NotificationManager();

  const profile = document.querySelector('.site-dashboard--user-profile');
  if (!profile) return;

  const trigger = document.querySelector('.site-dashboard--user-profile-button');
  if (!trigger) return;

  const controls = document.querySelector('.site-dashboard--user-profile-dropdown');
  if (!controls) return;

  // Icon click

  window.addEventListener('click', (event) => {
    event.stopPropagation();

    if (!controls.contains(event.target)) {
      controls.classList.add('hidden');
    }
  });

  trigger.addEventListener('click', (event) => {
    event.stopPropagation();

    controls.classList.toggle('hidden');
  });

  // Buttons click

  const popup = new Popup({
    popup: '.site-popup[data-popup="photo-upload"]',
    toggle: '.site-button[data-action="upload"]',
    close: '.site-popup-close[data-popup="photo-upload"]',
    window: '.site-popup-window[data-popup="photo-upload"]'
  });

  // Form

  const form = document.querySelector('#photo-upload-form');
  if (!form) return;

  const dropArea = form.querySelector('#drop-area');
  if (!dropArea) return;

  const input = form.querySelector('input[type="file"]');
  if (!input) return;

  const submit = form.querySelector('button[type="submit"]');
  if (!submit) return;

  const reset = form.querySelector('button[type="reset"]');
  if (!reset) return;

  const croppArea = form.querySelector('#photo-upload-result');
  if (!croppArea) return;

  ['dragenter', 'dragover'].forEach((eventName) => {
    dropArea.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();

      dropArea.classList.add('highlight');
    });
  });

  ['dragleave', 'drop'].forEach((eventName) => {
    dropArea.addEventListener(eventName, (event) => {
      event.preventDefault();
      event.stopPropagation();

      dropArea.classList.remove('highlight');
    });
  });

  const container = form.querySelector('#image-container');
  if (!container) return;

  const image = form.querySelector('#image-to-crop');
  if (!image) return;

  let cropper = new Cropper(image);

  function uploadImage (event) {
    event.preventDefault();
    event.stopPropagation();

    profile.classList.add('preload');

    popup.close.click();

    const cropped = cropper.getCroppedCanvas({ width: 130, height: 130 });

    cropped.toBlob((blob) => {
        const formData = new FormData(form);

        formData.append('photo', blob);

        (async function () {
            try {
                await fetch(`/wp-json/user/v1/upload-photo`, {
                    method: 'POST',
                    body: formData
                })
                .then((response) => response.json())
                .then((data) => {
                    if (data && !data.error) {
                        form.classList.remove('error');

                        _NotificationManager.sendNotification('success', 'Photo uploaded!', data.message);

                        simulatePhotoUpload();

                        dropArea.classList.remove('hidden');
                        croppArea.classList.add('hidden');
                    
                        if (cropper) {
                          cropper.destroy();
                        }
                    
                        input.files = null;
                        submit.setAttribute('disabled', '');

                        setTimeout(() => profile.classList.remove('preload'), 1000);
                    } else {
                        form.classList.add('error');

                        _NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                        profile.classList.remove('preload');
                    }
                })
                .catch(() => {
                    form.classList.add('error');

                    _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                    profile.classList.remove('preload');
                });
            } catch (error) {
                form.classList.add('error');

                _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                profile.classList.remove('preload');
            }
        })();
    });
  }

  const handleFile = (file) => {
    form.removeEventListener('submit', uploadImage);

    const reader = new FileReader();

    reader.onload = (event) => {
        image.src = event.target.result;

        if (cropper) {
            cropper.destroy();
        }

        dropArea.classList.add('hidden');
        croppArea.classList.remove('hidden');

        submit.removeAttribute('disabled');

        cropper = new Cropper(image, {
            aspectRatio: 1,
            dragMode: 'move',
            viewMode: 3,
            zoomOnWheel: false
        });

        const range = form.querySelector('input[type="range"]');
        if (!range) return;

        range.addEventListener('input', (e) => {
            const { value } = e.target;

            const progress = (value / range.max) * 100;

            range.style.background = `linear-gradient(to right, #ff8244 ${progress}%, #d5d5d5 ${progress}%)`;

            cropper.zoomTo(value / 100);
        });
    };

    reader.readAsDataURL(file);

    form.addEventListener('submit', uploadImage);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const transfer = event.dataTransfer;
    const file = transfer.files[0];

    handleFile(file);
  };

  dropArea.addEventListener('change', (event) => {
    const file = event.target.files[0];

    handleFile(file);
  });

  dropArea.addEventListener('drop', handleDrop, false);

  reset.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    dropArea.classList.remove('hidden');
    croppArea.classList.add('hidden');

    if (cropper) {
      cropper.destroy();
    }

    input.files = null;
    submit.setAttribute('disabled', '');

    popup.close.click();
  });

  // Delete photo

  const deleteTrigger = controls.querySelector('.site-button[data-action="delete"]');
  if (!deleteTrigger) return;

  deleteTrigger.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    profile.classList.add('preload');
  
    (async function () {
      try {
          await fetch(`/wp-json/user/v1/delete-photo`, {
              method: 'POST'
          })
          .then((response) => response.json())
          .then((data) => {
            if (data && !data.error) {
              _NotificationManager.sendNotification('success', 'Photo deleted!', data.message);

              simulatePhotoDeletion();

              setTimeout(() => profile.classList.remove('preload'), 1000);
            } else {
              _NotificationManager.sendNotification('error', 'An error occurred...', data.message);

              profile.classList.remove('preload');
            }
          })
          .catch(() => {
            _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            profile.classList.remove('preload');
          });
      } catch (error) {
        _NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

        profile.classList.remove('preload');
      }
    })();
  });
}
